(ns ui.components.query-builder.view
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.logging :as logging]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.query-builder.events :as events]
   [ui.components.query-builder.query-item :as query-item]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.util :as uu]))

(defn add-rule-type-selector
  [{:keys [db-path]}]
  (let [options [{:value :query-type/single-item
                  :label (loc/tr :query-type/single-item)}
                 {:value :query-type/and-collection
                  :label (loc/tr :query-type/and-collection)}
                 {:value :query-type/or-collection
                  :label (loc/tr :query-type/or-collection)}]]
    [labelled-input/view
     {:editor-type :editor.type/select
      :id          (str "query-builder-change-rule-type-" db-path)
      :placeholder (loc/tr :select)
      :value       (->> options
                        (cu/filter-by :value nil)
                        (first))
      :on-change   (fn [e]
                     (rf/dispatch [::events/add-query-item db-path e]))
      :options     options}]))

(defn view
  [{:keys [label rules db-path level parent-rule question-choices] :as props}]
  (let [coll-oper (:collection-operator parent-rule)]
    [:div
     {:class (uu/cm "flex flex-col gap-2"
                    (case coll-oper
                      :and "p-3 pb-4 bg-warning-light border border-solid border-warning-light-border rounded"
                      :or "p-3 pb-4 bg-success-light border border-solid border-success-light-border rounded"
                      nil))}
     (when (zero? level)
       [:span
        label])
     [:ul
      {:class "pl-0 min-w-64 flex flex-col justify-start relative"}
      (->> rules
           (map-indexed
            (fn [idx r]
              (let [qt (:query-type r)
                    question-options (get question-choices (:field r))]
                ^{:key (str "query-builder-" idx "-" db-path)}
                [:li
                 {:class "flex flex-col gap-1"}
                 [:div
                  {:class "flex flex-row gap-3"}
                  (cond
                    (= qt :query-type/single-item)
                    ^{:key (str ::q "-" (:field r))}
                    [query-item/view
                     (assoc props
                            :db-path (concat db-path [idx])
                            :options (->> question-options
                                          (map (fn [{:keys [db/id survey-question-option/label-translations]}]
                                                 {:id    id
                                                  :label (:ENG label-translations)}))
                                          (vec))
                            :rule r)]
                    (some #{qt} [:query-type/and-collection :query-type/or-collection])
                    [:<>
                     [view
                      (assoc props
                             :db-path (concat db-path [idx :rules])
                             :parent-rule r
                             :rules (:rules r)
                             :level (inc level))]]
                    :else
                    (logging/unimplemented "Unknown query type (QUERY BUILDER)"))
                  [button/square-secondary-open
                   {:tooltip    (loc/tr :query-builder/remove-condition)
                    :aria-label (loc/tr :query-builder/remove-condition)
                    :on-click   #(rf/dispatch [::events/remove-item db-path idx])}
                   [:i.fa.fa-times-circle]]]
                 (when (not= idx (dec (count rules)))
                   [:div
                    {:class "py-1 mb-0 block text-uppercase leading-3 text-xs text-base-light-text-paler"}
                    (case coll-oper
                      :or (loc/tr :query-builder-or-divider)
                      :and (loc/tr :query-builder-and-divider)
                      (pr-str coll-oper))])])))
           (doall))]
     (cond (or (and (zero? level)
                    (empty? rules))
               coll-oper)
           [:<>
            [:div
             (when coll-oper
               [:span
                {:class "mb-0 block text-uppercase leading-3 text-xs text-base-light-text-paler"}
                (case coll-oper
                  :or (loc/tr :or)
                  :and (loc/tr :and-rule-label)
                  nil)])
             [:div
              {:class "w-96 flex *:w-full"}
              [add-rule-type-selector props]]]])]))
